module.exports = __webpack_public_path__ + "img/red.1ba34832.png";